







































































































import LineItemsForm from "@/components/repair-estimate/LineItemsForm.vue";
import ClearanceApprovalResponseCardHistory from "@/components/clearance-approval/ClearanceApprovalResponseCardHistory.vue";
import ConfirmActionDialog from "@/components/utility/ConfirmActionDialog.vue";
import DropAreaMulti from "@/components/files/DropAreaMulti.vue";
import { IAction } from "@/components/utility/mmmint/MHeader.vue";
import Tooltip from "@/components/utility/tooltip.vue";
import { CurrencyEnum } from "@/lib/enum/currency.enum";
import { RequestStatusEnum } from "@/lib/enum/request-status-enum";
import { simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import { getAutocompleteFilter } from "@/lib/utility/filter";
import { handleError } from "@/lib/utility/handleError";
import { $t } from "@/lib/utility/t";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import RulesMixin from "@/mixins/RulesMixin.vue";
import { ClearanceApproval, IClearanceApproval } from "@/models/clearance-approval.entity";
import { mixins } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";

enum CreateClearanceApprovalWindow {
  FILE = "file"
}

enum ResponseType {
  ACCEPT,
  REQUEST,
  REJECT
}

@Component({
  components: {
    LineItemsForm,
    ClearanceApprovalResponseCardHistory,
    ConfirmActionDialog,
    DropAreaMulti,
    Tooltip
  },
  filters: { simpleDoubleDigitDate }
})
export default class ClearanceApprovalResponseCard extends mixins(PermissionMixin, RulesMixin) {
  readonly simpleDoubleDigitDate = simpleDoubleDigitDate;

  readonly getAutocompleteFilter = getAutocompleteFilter;

  readonly CurrencyEnum = CurrencyEnum;

  readonly RequestStatusEnum = RequestStatusEnum;

  readonly statusIconMap = ClearanceApproval.statusIconMap;

  readonly statusColorMap = ClearanceApproval.statusColorMap;

  readonly CreateClearanceApprovalWindow = CreateClearanceApprovalWindow;

  ResponseType = ResponseType;
  response: ResponseType = ResponseType.ACCEPT;

  step = CreateClearanceApprovalWindow.FILE;

  @Prop()
  value!: IClearanceApproval;

  @Prop()
  token!: string;

  loadingRespondReject = false;

  loadingRequestMoreData = false;

  isRejectDialogActive = false;

  isRequestMoreDialogActive = false;

  rejectReason = "";

  requestMoreDataReason = "";

  isDialogActive = false;

  loading = false;

  isValid = false;

  file: File | null = null;

  reason = "";

  get actions(): IAction[] {
    const actions: IAction[] = [];
    actions.push({
      text: $t("clearanceApproval.response.makeOffer"),
      icon: ClearanceApproval.statusIconMap.get(RequestStatusEnum.ACCEPTED),
      color: ClearanceApproval.statusColorMap.get(RequestStatusEnum.ACCEPTED),
      loading: this.loading,
      exec: () => (this.isDialogActive = true),
      key: "makeOffer"
    });

    actions.push({
      text: $t("clearanceApproval.response.requestMore"),
      icon: ClearanceApproval.statusIconMap.get(RequestStatusEnum.REQUEST_MORE_DATA),
      color: ClearanceApproval.statusColorMap.get(RequestStatusEnum.REQUEST_MORE_DATA),
      loading: this.loadingRequestMoreData,
      exec: () => (this.isRequestMoreDialogActive = true),
      key: "requestMore"
    });

    actions.push({
      text: $t("clearanceApproval.response.reject"),
      icon: ClearanceApproval.statusIconMap.get(RequestStatusEnum.REJECTED_BY_REQUESTED),
      color: ClearanceApproval.statusColorMap.get(RequestStatusEnum.REJECTED_BY_REQUESTED),
      loading: this.loadingRespondReject,
      exec: () => (this.isRejectDialogActive = true),
      key: "reject"
    });

    return actions;
  }

  get leftText(): string {
    switch (this.step) {
      case CreateClearanceApprovalWindow.FILE:
        return $t("close");
      default:
        return "";
    }
  }

  get rightText(): string {
    switch (this.step) {
      case CreateClearanceApprovalWindow.FILE:
        switch (this.response) {
          case ResponseType.ACCEPT:
            return $t("clearanceApproval.response.confirmOffer");
          case ResponseType.REQUEST:
            return $t("clearanceApproval.response.confirmOffer");
          case ResponseType.REJECT:
            return $t("clearanceApproval.response.confirmOffer");
          default:
            return $t("clearanceApproval.response.confirmOffer");
        }
      default:
        return "";
    }
  }

  get hideRight() {
    switch (this.step) {
      case CreateClearanceApprovalWindow.FILE:
        switch (this.response) {
          case ResponseType.ACCEPT:
            return false; // Allow progression with or without file for clearance approvals
          default:
            return false;
        }
      default:
        return false;
    }
  }

  get files(): File[] {
    if (this.file) {
      return [this.file];
    }
    return [];
  }

  set files(files: File[]) {
    if (files.length > 0) {
      this.file = files[0];
    } else {
      this.file = null;
    }
  }

  removeFile() {
    this.file = null;

    // hack to reset input field
    this.response = ResponseType.REJECT;
    this.$nextTick(() => {
      this.response = ResponseType.ACCEPT;
    });
  }

  open() {
    this.step = CreateClearanceApprovalWindow.FILE;
    this.isDialogActive = true;
  }

  close() {
    this.isDialogActive = false;
    this.isRejectDialogActive = false;
    this.isRequestMoreDialogActive = false;
  }

  rightClick() {
    if (this.step == CreateClearanceApprovalWindow.FILE) {
      if (this.response === ResponseType.REJECT) {
        return this.respondReject();
      } else if (this.response === ResponseType.REQUEST) {
        return this.respondRequestMoreData();
      } else {
        // For ACCEPT, go directly to confirmation
        return this.confirmClearanceApprovalResponse();
      }
    }
  }

  leftClick() {
    switch (this.step) {
      case CreateClearanceApprovalWindow.FILE:
        this.close();

        // reset form
        this.file = null;
        this.response = ResponseType.REQUEST;
        this.$nextTick(() => {
          this.response = ResponseType.ACCEPT;
        });
        break;
    }
  }

  async confirmClearanceApprovalResponse() {
    this.loading = true;
    try {
      await this.value.respondAccept(this.token, this.file || undefined);

      this.$toast.success(this.$t("clearanceApproval.response.success"));
    } catch (error) {
      handleError(error);
    } finally {
      this.loading = false;
      this.close();
    }
  }

  async respondRequestMoreData() {
    this.loadingRequestMoreData = true;
    try {
      await this.value.respondReject(this.token, {
        status: RequestStatusEnum.REQUEST_MORE_DATA,
        message: this.requestMoreDataReason || undefined
      });
    } catch (error) {
      handleError(error);
    } finally {
      this.$toast.success(this.$t("clearanceApproval.response.successReject"));
      this.loadingRequestMoreData = false;
      this.close();
    }
  }

  async respondReject() {
    this.loadingRespondReject = true;
    try {
      await this.value.respondReject(this.token, {
        status: RequestStatusEnum.REJECTED_BY_REQUESTED,
        message: this.rejectReason || undefined
      });
    } catch (error) {
      handleError(error);
    } finally {
      this.$toast.success(this.$t("clearanceApproval.response.successReject"));
      this.loadingRespondReject = false;
      this.close();
    }
  }
}
